/* Fantastick V8.9 — contextual help for special modes and existing layouts. */
(function () {
  "use strict";
  if (window.FantastickConfiguratorTour && window.FantastickConfiguratorTour.version === "8.9.0") return;

  var memory = window.__fantastickTourSeen || (window.__fantastickTourSeen = new Set());
  var clamp = function (n, a, b) { return Math.min(b, Math.max(a, n)); };
  var text = function (value, fallback) { return typeof value === "string" && value.trim() ? value.trim() : (fallback || ""); };
  var visible = function (node) {
    return Boolean(node && node.isConnected && !node.closest("[hidden]") && node.getClientRects().length && window.getComputedStyle(node).visibility !== "hidden");
  };
  var area = function (node) { return node && (node.closest(".fkc__step, .fkc__checkout") || node); };
  var heading = function (node, fallback) {
    var label = node && node.querySelector(".fkc__module-title, .fkc__step-title");
    return text(label && label.textContent, fallback);
  };

  function buildSteps(instance, settings) {
    var el = instance.elements, root = instance.root;
    var product = [], design = [];
    var add = function (list, key, title, description, nodes) {
      var targets = nodes.filter(visible);
      if (targets.length) list.push({ key: key, title: title, description: description, targets: targets });
    };
    add(product, "fit", "Passform auswählen", "Wähle Herren oder Damen. Dazu zeigen wir dir die passenden Größen, Farben und das passende Produktbild.", [area(el.fitBar)]);
    add(product, "size", "Größe auswählen", "Wähle deine Größe. Ausgegraute Größen sind nicht verfügbar. „Andere Farbe“ bedeutet: Diese Größe gibt es noch in einer anderen Farbe. Der angezeigte Preis gehört zu deiner Auswahl.", [area(el.sizeBar)]);
    add(product, "fabric", "Stofffarbe auswählen", "Tippe auf die Stofffarbe für dein Produkt. Nicht verfügbare Kombinationen sind gesperrt. Die Live-Vorschau zeigt die gewählte Farbe.", [area(el.fabricBar)]);
    instance.textFields.forEach(function (field, index) {
      var input = (el.textInputs || []).find(function (node) { return node.dataset.fkcTextKey === field.key; });
      var module = input && input.closest("[data-fkc-text-module]");
      var styles = Array.from(root.querySelectorAll("[data-fkc-style-module]")).find(function (node) { return node.dataset.fkcTextKey === field.key; });
      add(design, "text-" + index, heading(module, field.heading),
        "Trage hier deinen Namen oder Wunschtext ein. Maximal " + field.maxChars + " Zeichen. " +
        (field.required ? "Dieses Textfeld ist erforderlich." : "Dieses Textfeld ist freiwillig.") +
        (instance.textFields.length > 1 ? " Jedes Textfeld besitzt seine eigene Schriftgestaltung." : ""), [module || input]);
      var romanStyle = index === 0 && instance.special && instance.special.mode() === "roman";
      add(design, "style-" + index, romanStyle ? "Garnfarbe wählen" : (instance.textFields.length > 1 ? "Schrift für „" + field.heading + "“" : "Schrift und Garnfarbe"),
        romanStyle ? "Wähle die Garnfarbe. Die Schrift für römische Zahlen ist für diesen Modus festgelegt." : "Wähle die Schriftart und die Garnfarbe für diesen Text. Änderungen siehst du direkt in der Vorschau.", [styles]);
    });
    if (instance.positionSelectorEnabled) add(design, "position", "Position wählen", "Wähle Mittig oder Rechts für die Anordnung deiner Stickerei. Die passenden Positionen sind bereits für dieses Produkt eingestellt.", [area(el.alignCenter)]);
    var specialMode = instance.special && instance.special.mode();
    var motifHelp = instance.motifCategories && instance.motifCategories.length ? "Wähle zuerst eine Motiv-Kategorie und danach dein Lieblingsmotiv. Beim Kategorienwechsel bleibt das ausgewählte Motiv erhalten. „Ohne Motiv“ entfernt es aus der Vorschau." : "Wähle ein Motiv oder „Ohne Motiv“. Die Vorschau zeigt dir deine Auswahl zusammen mit deinem Text.";
    if (specialMode === "cards") motifHelp += " Bei der Spielkarte wählst du Symbol und Farbe und gibst bis zu zwei Zeichen ein.";
    if (specialMode === "roman") motifHelp += " Gib Text oder ein Datum ein; Zahlen werden automatisch in römische Ziffern umgewandelt.";
    if (instance.motifEnabled) add(design, "motif", "Motiv wählen", motifHelp, [area(el.motifTrack)]);

    var productExtra = text(settings.product_text), designExtra = text(settings.design_text);
    var steps;
    if (settings.mode === "detailed") {
      steps = product.concat(design);
      if (product.length && productExtra) product[0].description += "\n\n" + productExtra;
      if (design.length && designExtra) design[0].description += "\n\n" + designExtra;
    } else {
      steps = [];
      [
        { key: "product", title: text(settings.product_title, "Produkt auswählen"), list: product, extra: productExtra },
        { key: "design", title: text(settings.design_title, "Deine Stickerei gestalten"), list: design, extra: designExtra }
      ].forEach(function (group) {
        if (!group.list.length) return;
        steps.push({ key: group.key, title: group.title,
          description: group.list.map(function (step) { return step.title + ": " + step.description; }).join("\n\n") + (group.extra ? "\n\n" + group.extra : ""),
          targets: group.list.map(function (step) { return step.targets[0]; }) });
      });
    }
    var previewText = "Bild oder ⛶: Großansicht öffnen. Dort mit + oder zwei Fingern bis 500 % zoomen. Die Seite dahinter bleibt stehen. Speichern über „Vorschau speichern“, schließen über X oder „Weiter gestalten“.";
    if (instance.mobileStickyPreviewEnabled()) previewText += " Mit dem Pfeil oben klappst du die kleine Vorschau ein oder aus.";
    if (visible(el.previewPin)) {
      previewText += " Stecknadel an: Vorschau beim Scrollen mitnehmen. Stecknadel aus: Sie bleibt oben auf der Seite und scrollt aus dem Bildschirm.";
    } else if (typeof instance.previewFollowsScroll === "function" && !instance.previewFollowsScroll()) {
      previewText += " Die kleine Vorschau bleibt oben auf der Seite. Scrolle nach oben, um sie erneut anzusehen.";
    }
    if (specialMode !== "cards" && typeof instance.getMotifTextLayout === "function" && instance.getMotifTextLayout() === "independent") {
      previewText += " Text und Motiv haben feste, getrennte Plätze. Wenn du eines entfernst, bleibt das andere an seiner Position.";
    }
    if (specialMode !== "cards" && typeof instance.getMotifTextLayout === "function" && instance.getMotifTextLayout() === "text_fixed") {
      previewText += " Dein Text bleibt an seinem festen Platz. Das Motiv wird darüber oder links daneben angeordnet. Ein anderes oder entferntes Motiv verschiebt den Text nicht.";
    }
    if (specialMode !== "cards" && typeof instance.getMotifTextLayout === "function" && instance.getMotifTextLayout() === "balanced"
      && typeof instance.getBalancedDirection === "function" && instance.getBalancedDirection() !== "legacy") {
      previewText += " Text und Motiv werden gemeinsam zentriert. Ihre Anordnung ist für die gewählte Position vorgegeben und bleibt beim Eingeben oder Wechseln erhalten.";
    }
    if (specialMode === "cards") previewText += " Das Kartensymbol bleibt über den eingegebenen Zeichen; die gewählte Position gilt für beides.";
    var extra = text(settings.preview_text);
    if (extra) previewText += "\n\n" + extra;
    add(steps, "preview", text(settings.preview_title, "Dein Ergebnis prüfen"), previewText, [root.querySelector(".fkc__preview-sticky") || el.previewColumn]);
    add(steps, "checkout", text(settings.order_title, "Fertig? Ab in den Warenkorb."),
      text(settings.order_text, "Prüfe den Preis und lege dein gestaltetes Produkt in den Warenkorb. Deine Angaben und das Vorschaubild werden mitgegeben."),
      [root.querySelector('[data-fkc-tour-area="checkout"]') || area(el.addButton)]);
    return steps;
  }

  function storageKey(instance, settings) {
    var el = instance.elements;
    var features = [visible(area(el.fitBar)) ? "fit" : "", visible(area(el.sizeBar)) ? "size" : "",
      instance.textFields.length, instance.positionSelectorEnabled ? "position" : "", instance.motifEnabled ? "motif" : ""].join("-");
    return "fantastickConfiguratorTour:" + text(settings.revision, "1").slice(0, 60) + ":" + features;
  }

  function Tour(instance) {
    this.instance = instance;
    this.root = instance.root;
    this.settings = instance.config.tour;
    this.button = this.root.querySelector("[data-fkc-tour-start]");
    this.key = storageKey(instance, this.settings);
    this.listeners = [];
    this.phase = "closed";
    this.frame = 0;
    this.generation = 0;
    this.autoTimer = 0;
    this.autoSuppressed = false;
    this.destroyed = false;
    this.desktopScrollPasses = 0;
    this.scrollParents = new Map();
    this.temporaryStyles = [];
    this.createDialog();
    this.bind();
    if (this.button) { this.button.disabled = false; this.button.setAttribute("aria-controls", this.dialog.id); }
    this.offerOnce();
  }
  Tour.prototype.listen = function (node, event, handler, options) {
    if (!node) return;
    node.addEventListener(event, handler, options);
    this.listeners.push(function () { node.removeEventListener(event, handler, options); });
  };
  Tour.prototype.createDialog = function () {
    var dialog = document.createElement("dialog");
    dialog.className = "fkc-tour";
    dialog.id = "FkcTour-" + this.root.dataset.fkcSectionId;
    dialog.setAttribute("aria-label", "Hilfe zum Produktkonfigurator");
    dialog.style.setProperty("--fkc-tour-opacity", String(clamp(Number(this.settings.overlay_opacity) || 65, 40, 80) / 100));
    // Only static markup here. All merchant and product text uses textContent below.
    dialog.innerHTML = '<svg class="fkc-tour__shade" aria-hidden="true"><path fill-rule="evenodd"></path></svg>' +
      '<div class="fkc-tour__ring" hidden></div><svg class="fkc-tour__drawing" aria-hidden="true"><path></path></svg>' +
      '<section class="fkc-tour__panel"><header class="fkc-tour__head">' +
      '<p class="fkc-tour__progress"></p><h2 class="fkc-tour__title" tabindex="-1"></h2>' +
      '<button type="button" class="fkc-tour__close" aria-label="Hilfe schließen"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="m6 6 12 12M18 6 6 18" stroke="currentColor" fill="none" stroke-width="2" stroke-linecap="round"/></svg></button>' +
      '</header><div class="fkc-tour__description"></div><footer class="fkc-tour__navigation">' +
      '<button type="button" class="fkc-tour__back">Zurück</button>' +
      '<button type="button" class="fkc-tour__skip">Überspringen</button>' +
      '<button type="button" class="fkc-tour__next">Tour starten</button></footer></section>';
    this.dialog = dialog;
    this.panel = dialog.querySelector(".fkc-tour__panel");
    this.title = dialog.querySelector(".fkc-tour__title");
    this.progress = dialog.querySelector(".fkc-tour__progress");
    this.description = dialog.querySelector(".fkc-tour__description");
    this.back = dialog.querySelector(".fkc-tour__back");
    this.skip = dialog.querySelector(".fkc-tour__skip");
    this.next = dialog.querySelector(".fkc-tour__next");
    this.shade = dialog.querySelector(".fkc-tour__shade");
    this.shadePath = this.shade.querySelector("path");
    this.ring = dialog.querySelector(".fkc-tour__ring");
    this.drawing = dialog.querySelector(".fkc-tour__drawing");
    this.arrow = this.drawing.querySelector("path");
    this.title.id = dialog.id + "-title";
    this.description.id = dialog.id + "-description";
    dialog.setAttribute("aria-labelledby", this.title.id);
    dialog.setAttribute("aria-describedby", this.description.id);
    document.body.appendChild(dialog);
  };
  Tour.prototype.bind = function () {
    var self = this;
    this.listen(this.button, "click", function () { self.open(false); });
    this.listen(this.dialog.querySelector(".fkc-tour__close"), "click", function () { self.dismiss(); });
    this.listen(this.skip, "click", function () { self.dismiss(); });
    this.listen(this.next, "click", function () {
      if (self.phase === "intro") self.begin();
      else if (self.phase === "done") { self.remember("completed"); self.close(true); }
      else self.show(self.index + 1);
    });
    this.listen(this.back, "click", function () { self.show(self.index - 1); });
    this.listen(this.dialog, "cancel", function (event) { event.preventDefault(); self.dismiss(); });
    this.listen(this.dialog, "close", function () { if (!self.dialog.open && self.phase !== "closed") self.close(false); });
    this.listen(this.dialog, "keydown", function (event) {
      if (event.key === "ArrowRight" && self.phase === "step") { event.preventDefault(); self.show(self.index + 1); }
      else if (event.key === "ArrowLeft" && self.phase === "step") { event.preventDefault(); self.show(Math.max(0, self.index - 1)); }
      else if (["ArrowUp", "ArrowDown", "PageUp", "PageDown", "Home", "End"].indexOf(event.key) >= 0 && !self.description.contains(event.target)) event.preventDefault();
    });
    ["wheel", "touchmove"].forEach(function (eventName) {
      self.listen(self.dialog, eventName, function (event) {
        if (!self.description.contains(event.target)) event.preventDefault();
      }, { passive: false });
    });
    this.listen(window, "resize", function () { self.scheduleLayout(true); }, { passive: true });
    this.listen(window, "scroll", function () { self.scheduleLayout(false); }, { passive: true });
    // Scroll events from an inner theme container do not bubble to window.
    this.listen(document, "scroll", function () {
      if (!window.matchMedia("(max-width: 899px)").matches) self.scheduleLayout(false);
    }, { capture: true, passive: true });
    if (window.visualViewport) {
      this.listen(window.visualViewport, "resize", function () { self.scheduleLayout(true); }, { passive: true });
      this.listen(window.visualViewport, "scroll", function () { self.scheduleLayout(false); }, { passive: true });
    }
    if (window.ResizeObserver) {
      this.resizeObserver = new ResizeObserver(function () {
        self.scheduleLayout(self.phase === "step" && !window.matchMedia("(max-width: 899px)").matches);
      });
      this.resizeObserver.observe(this.panel);
      this.resizeObserver.observe(this.root);
    }
    this.listen(window, "pagehide", function () { self.close(false); });
    ["pointerdown", "input"].forEach(function (eventName) {
      self.listen(self.root, eventName, function () { self.autoSuppressed = true; window.clearTimeout(self.autoTimer); }, { passive: true });
    });
    if (window.MutationObserver) {
      this.modalObserver = new MutationObserver(function () {
        if (self.dialog.open && self.otherModalOpen()) self.close(false);
      });
      this.modalObserver.observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ["open"] });
    }
  };
  Tour.prototype.otherModalOpen = function () {
    return Array.from(document.querySelectorAll("dialog[open], #Details-menu-drawer-container[open], header-drawer > details[open]")).some(function (node) { return node !== this.dialog; }, this);
  };
  Tour.prototype.seen = function () {
    if (memory.has(this.key)) return true;
    try { return Boolean(window.localStorage.getItem(this.key)); } catch (_) { return false; }
  };
  Tour.prototype.remember = function (status) {
    if (this.instance.config.designMode || this.root.classList.contains("fkc--design-mode")) return;
    memory.add(this.key);
    try { window.localStorage.setItem(this.key, status); } catch (_) { /* one offer per document remains */ }
  };
  Tour.prototype.offerOnce = function () {
    if (this.settings.auto_offer === false || this.seen() || this.root.classList.contains("fkc--design-mode")) return;
    var self = this;
    var offer = function () {
      window.clearTimeout(self.autoTimer);
      self.autoTimer = window.setTimeout(function () {
        if (self.destroyed || self.autoSuppressed || self.seen() || document.hidden || !visible(self.button)) return;
        if (self.otherModalOpen() || window.__fantastickTourOwner) return;
        var r = self.button.getBoundingClientRect();
        if (r.top < 0 || r.bottom > window.innerHeight) return;
        // Do not cover a Shopify privacy banner or interrupt a form field.
        if (visible(document.querySelector('#shopify-pc__banner')) || /^(INPUT|TEXTAREA|SELECT)$/.test(document.activeElement && document.activeElement.tagName)) return;
        self.open(true);
      }, 750);
    };
    if (window.IntersectionObserver && this.button) {
      this.intersectionObserver = new IntersectionObserver(function (entries) {
        if (entries.some(function (entry) { return entry.isIntersecting; })) offer();
        else window.clearTimeout(self.autoTimer);
      }, { threshold: 1 });
      this.intersectionObserver.observe(this.button);
    } else offer();
  };
  Tour.prototype.open = function (automatic) {
    if (this.destroyed || this.phase !== "closed" || this.instance.busy || this.root.dataset.fkcReady !== "true") return;
    if (this.otherModalOpen()) return;
    if (typeof this.dialog.showModal !== "function") return;
    if (window.__fantastickTourOwner && window.__fantastickTourOwner !== this) window.__fantastickTourOwner.close(false);
    this.autoSuppressed = true;
    window.clearTimeout(this.autoTimer);
    this.saved = { x: window.scrollX, y: window.scrollY, collapsed: this.instance.state.previewCollapsed,
      opener: automatic ? document.activeElement : this.button,
      hadClass: document.documentElement.classList.contains("fkc-tour-open") };
    if (document.activeElement && /^(INPUT|TEXTAREA|SELECT)$/.test(document.activeElement.tagName)) document.activeElement.blur();
    this.instance.setTextEntryMode(false);
    window.__fantastickTourOwner = this;
    document.documentElement.classList.add("fkc-tour-open");
    try { this.dialog.showModal(); }
    catch (_) { this.close(false); return; }
    this.phase = "intro";
    this.render(text(this.settings.intro_title, "Dein Produkt. Schritt für Schritt."),
      text(this.settings.intro_text, "Wir zeigen dir die wichtigsten Funktionen. Du kannst die Hilfe jederzeit über das Fragezeichen erneut öffnen."), "Kurze Orientierung");
  };
  Tour.prototype.begin = function () {
    this.remember("started");
    this.root.classList.add("is-tour-active");
    this.instance.setPreviewCollapsed(false, false);
    this.steps = buildSteps(this.instance, this.settings);
    this.show(0);
  };
  Tour.prototype.show = function (index) {
    if (!this.dialog.open || !this.steps) return;
    if (index < 0) return;
    // Re-evaluate DOM visibility after a theme or variant change; never point at a removed field.
    while (index < this.steps.length && !this.steps[index].targets.some(visible)) index += 1;
    this.index = index;
    if (index >= this.steps.length) {
      this.phase = "done";
      this.remember("completed");
      this.render(text(this.settings.done_title, "Jetzt bist du dran."), text(this.settings.done_text, "Gestalte dein Produkt in Ruhe. Das Fragezeichen bleibt jederzeit für dich da."), "Alles gezeigt");
      return;
    }
    this.phase = "step";
    var step = this.steps[index];
    this.render(step.title, step.description, "Schritt " + (index + 1) + " von " + this.steps.length);
    this.scheduleLayout(true);
  };
  Tour.prototype.render = function (title, description, progress) {
    this.generation += 1;
    this.desktopScrollPasses = 0;
    this.panel.dataset.fkcTourPhase = this.phase;
    this.title.textContent = title;
    this.description.textContent = description;
    this.description.scrollTop = 0;
    this.progress.textContent = progress;
    this.back.hidden = this.phase !== "step";
    this.back.disabled = this.index === 0;
    this.skip.hidden = this.phase !== "intro";
    this.next.textContent = this.phase === "intro" ? "Tour starten" : this.phase === "done" ? "Alles verstanden" : this.index === this.steps.length - 1 ? "Fertig" : "Weiter →";
    this.title.focus({ preventScroll: true });
    this.scheduleLayout(false);
  };
  Tour.prototype.scheduleLayout = function (scroll) {
    if (!this.dialog.open || this.destroyed) return;
    if (scroll) this.desktopScrollPasses = 6;
    this.needsScroll = this.needsScroll || scroll;
    if (this.frame) return;
    this.frame = window.requestAnimationFrame(function () {
      this.frame = 0;
      var move = this.needsScroll;
      this.needsScroll = false;
      this.layout(move);
    }.bind(this));
  };
  Tour.prototype.setTemporaryStyle = function (node, property, value) {
    if (!this.temporaryStyles.some(function (entry) { return entry.node === node && entry.property === property; })) {
      this.temporaryStyles.push({ node: node, property: property,
        value: node.style.getPropertyValue(property), priority: node.style.getPropertyPriority(property) });
    }
    node.style.setProperty(property, value, "important");
  };
  Tour.prototype.desktopScrollParents = function (target) {
    var parents = [];
    for (var node = target.parentElement; node && node !== document.body && node !== document.documentElement; node = node.parentElement) {
      var overflow = window.getComputedStyle(node).overflowY;
      if (node.clientHeight > 0 && node.scrollHeight > node.clientHeight + 1 && /^(auto|scroll|hidden)$/.test(overflow)) parents.push(node);
    }
    return parents;
  };
  Tour.prototype.rememberScrollParent = function (node) {
    if (this.scrollParents.has(node)) return;
    this.scrollParents.set(node, { x: node.scrollLeft, y: node.scrollTop,
      attribute: node.getAttribute("data-fkc-tour-scroll-root") });
    node.setAttribute("data-fkc-tour-scroll-root", "");
  };
  Tour.prototype.scrollDesktopWindow = function (left, top) {
    window.scrollTo({ top: top, left: left, behavior: "instant" });
    var scrollingElement = document.scrollingElement;
    // Also used on close so a fallback scroll does not lose the original page position.
    if (scrollingElement) {
      if (Math.abs(window.scrollY - top) > 1) scrollingElement.scrollTop = top;
      if (Math.abs(window.scrollX - left) > 1) scrollingElement.scrollLeft = left;
    }
  };
  Tour.prototype.scrollDesktopTarget = function (target, top, bottom) {
    // Some themes fix the body for every open dialog. Keep programmatic tour scrolling
    // available on desktop, and restore the exact inline declarations when closing.
    if (window.getComputedStyle(document.body).position === "fixed") {
      this.setTemporaryStyle(document.body, "position", "static");
      this.setTemporaryStyle(document.body, "top", "auto");
    }
    var moved = false;
    var offset = function (box, start, end) {
      if (box.top < start - 1 || box.bottom > end + 1) {
        // A tall section is aligned at its heading; do not chase its lower edge forever.
        if (box.height > end - start || box.top < start) return box.top - start;
        return box.bottom - end;
      }
      return 0;
    };
    this.desktopScrollParents(target).forEach(function (parent) {
      this.rememberScrollParent(parent);
      var bounds = parent.getBoundingClientRect();
      var inset = parent.clientTop || 0;
      var start = Math.max(top, bounds.top + inset + 8);
      var end = Math.min(bottom, bounds.top + inset + parent.clientHeight - 8);
      // If the parent is outside the viewport, first reveal the target within that
      // parent. The document scroll below then brings the parent itself into view.
      if (end - start < 32) { start = bounds.top + inset + 8; end = bounds.top + inset + parent.clientHeight - 8; }
      var delta = offset(target.getBoundingClientRect(), start, end);
      var desired = clamp(parent.scrollTop + delta, 0, Math.max(0, parent.scrollHeight - parent.clientHeight));
      if (Math.abs(desired - parent.scrollTop) > 1) {
        parent.scrollTop = desired;
        moved = true;
      }
    }, this);
    var delta = offset(target.getBoundingClientRect(), top, bottom);
    if (Math.abs(delta) > 1) {
      var before = window.scrollY;
      var desired = Math.max(0, before + delta);
      this.scrollDesktopWindow(window.scrollX, desired);
      moved = Math.abs(window.scrollY - before) > 1 || moved;
    }
    return moved;
  };
  Tour.prototype.desktopBounds = function (target, width, top, bottom) {
    var bounds = { left: 8, right: width - 8, top: top, bottom: bottom };
    this.desktopScrollParents(target).forEach(function (parent) {
      var r = parent.getBoundingClientRect();
      bounds.left = Math.max(bounds.left, r.left + (parent.clientLeft || 0));
      bounds.right = Math.min(bounds.right, r.right);
      bounds.top = Math.max(bounds.top, r.top + (parent.clientTop || 0));
      bounds.bottom = Math.min(bounds.bottom, r.top + (parent.clientTop || 0) + parent.clientHeight);
    });
    return bounds;
  };
  Tour.prototype.restoreDesktopScrolling = function () {
    this.scrollParents.forEach(function (saved, node) {
      if (node.isConnected) {
        node.scrollLeft = saved.x;
        node.scrollTop = saved.y;
      }
      if (saved.attribute === null) node.removeAttribute("data-fkc-tour-scroll-root");
      else node.setAttribute("data-fkc-tour-scroll-root", saved.attribute);
    });
    this.scrollParents.clear();
    this.temporaryStyles.reverse().forEach(function (entry) {
      if (entry.value) entry.node.style.setProperty(entry.property, entry.value, entry.priority);
      else entry.node.style.removeProperty(entry.property);
    });
    this.temporaryStyles = [];
  };
  Tour.prototype.layout = function (move) {
    if (!this.dialog.open) return;
    var width = this.dialog.clientWidth, height = this.dialog.clientHeight;
    if (width < 1 || height < 1) return;
    var whole = "M0 0H" + width + "V" + height + "H0Z";
    this.shade.setAttribute("viewBox", "0 0 " + width + " " + height);
    this.drawing.setAttribute("viewBox", "0 0 " + width + " " + height);
    this.arrow.setAttribute("d", "");
    this.ring.hidden = true;
    this.shadePath.setAttribute("d", whole);
    if (this.phase !== "step") return;
    var step = this.steps[this.index], nodes = step.targets.filter(visible);
    if (!nodes.length) { this.show(this.index + 1); return; }
    var primary = nodes[0];
    var mobile = window.matchMedia("(max-width: 899px)").matches;
    var header = document.querySelector("#header-component");
    var topLimit = Math.max(16, header ? Math.min(height * .22, header.getBoundingClientRect().bottom + 12) : 16);
    var panelHeight = this.panel.offsetHeight;
    var primaryBox = primary.getBoundingClientRect();
    var panelWidth = this.panel.offsetWidth;
    var panelBelow = !mobile && primaryBox.left < panelWidth + 36 && width - primaryBox.right < panelWidth + 36;
    var bottomLimit = mobile || panelBelow ? Math.max(topLimit + 24, height - panelHeight - 40) : height - 20;
    if (mobile && move) {
      var current = primary.getBoundingClientRect();
      var desired = topLimit + 12;
      var delta = current.top - desired;
      if (Math.abs(delta) > 1) window.scrollTo({ top: Math.max(0, window.scrollY + delta), left: window.scrollX, behavior: "instant" });
    }
    if (!mobile && this.desktopScrollPasses > 0) {
      this.desktopScrollPasses -= 1;
      var moved = this.scrollDesktopTarget(primary, topLimit + 12, bottomLimit - 12);
      // Measure again in the next rendered frame. Headers, scroll anchoring and a
      // theme's scroll container can settle after the initial scroll request.
      if ((move || moved) && this.desktopScrollPasses > 0) { this.scheduleLayout(false); return; }
      this.desktopScrollPasses = 0;
    }
    var first = primary.getBoundingClientRect();
    var rect = { left: first.left, right: first.right, top: first.top, bottom: first.bottom };
    // Compact tour: include adjacent controls only when the whole group fits above the card.
    nodes.slice(1).forEach(function (node) {
      var r = node.getBoundingClientRect();
      if (r.top >= topLimit && r.bottom <= bottomLimit && Math.abs(r.left - first.left) < 100) {
        rect.left = Math.min(rect.left, r.left); rect.right = Math.max(rect.right, r.right); rect.bottom = Math.max(rect.bottom, r.bottom);
      }
    });
    if (!mobile) {
      var bounds = this.desktopBounds(primary, width, topLimit, bottomLimit);
      rect.left = Math.max(rect.left, bounds.left);
      rect.right = Math.min(rect.right, bounds.right);
      rect.top = Math.max(rect.top, bounds.top);
      rect.bottom = Math.min(rect.bottom, bounds.bottom);
      // Never draw a misleading spotlight at the screen edge for an invisible target.
      if (rect.right - rect.left < 24 || rect.bottom - rect.top < 24) return;
    }
    var x = clamp(rect.left - 6, 8, width - 32), y = clamp(rect.top - 6, topLimit, bottomLimit - 24);
    var right = clamp(rect.right + 6, x + 24, width - 8), bottom = clamp(rect.bottom + 6, y + 24, bottomLimit);
    var w = right - x, h = bottom - y;
    this.ring.hidden = false;
    this.ring.style.left = x + "px"; this.ring.style.top = y + "px";
    this.ring.style.width = w + "px"; this.ring.style.height = h + "px";
    // Rounded rectangular cutout in one SVG path; underlying controls stay inert.
    var r = Math.min(14, w / 2, h / 2);
    this.shadePath.setAttribute("d", whole + " M" + (x + r) + " " + y + "H" + (right - r) + "Q" + right + " " + y + " " + right + " " + (y + r) + "V" + (bottom - r) + "Q" + right + " " + bottom + " " + (right - r) + " " + bottom + "H" + (x + r) + "Q" + x + " " + bottom + " " + x + " " + (bottom - r) + "V" + (y + r) + "Q" + x + " " + y + " " + (x + r) + " " + y + "Z");
    if (!mobile) {
      var pw = this.panel.offsetWidth;
      var px = right + 24;
      if (px + pw > width - 12) px = x - pw - 24;
      var py = y;
      if (px < 12 || panelBelow) { px = width - pw - 12; py = bottom + 24; }
      this.panel.style.left = clamp(px, 12, width - pw - 12) + "px";
      this.panel.style.top = clamp(py, 12, height - panelHeight - 12) + "px";
    }
    if (this.settings.show_arrow !== false) this.drawArrow({ left: x, top: y, right: right, bottom: bottom }, mobile);
  };
  Tour.prototype.drawArrow = function (rect, mobile) {
    var p = this.panel.getBoundingClientRect();
    var x1, y1, x2, y2;
    if (mobile || p.top >= rect.bottom) {
      x1 = p.left + Math.min(p.width - 28, p.width * .72); y1 = p.top - 8;
      x2 = clamp(x1 - 24, rect.left + 12, rect.right - 12); y2 = rect.bottom + 5;
    } else if (p.left >= rect.right) {
      x1 = p.left - 8; y1 = p.top + 34; x2 = rect.right + 5; y2 = clamp(y1 + 12, rect.top + 8, rect.bottom - 8);
    } else if (p.right <= rect.left) {
      x1 = p.right + 8; y1 = p.top + 34; x2 = rect.left - 5; y2 = clamp(y1 + 12, rect.top + 8, rect.bottom - 8);
    } else return;
    if (Math.hypot(x2 - x1, y2 - y1) < 18) return;
    var cx = (x1 + x2) / 2 + 16, cy = (y1 + y2) / 2;
    var angle = Math.atan2(y2 - cy, x2 - cx), len = 8;
    this.arrow.setAttribute("d", "M" + x1 + " " + y1 + "Q" + cx + " " + cy + " " + x2 + " " + y2 + "M" + (x2 - len * Math.cos(angle - .6)) + " " + (y2 - len * Math.sin(angle - .6)) + "L" + x2 + " " + y2 + "L" + (x2 - len * Math.cos(angle + .6)) + " " + (y2 - len * Math.sin(angle + .6)));
  };
  Tour.prototype.dismiss = function () { this.remember("dismissed"); this.close(true); };
  Tour.prototype.close = function (restoreFocus) {
    if (!this.saved && !this.dialog.open) return;
    this.generation += 1;
    this.phase = "closed";
    if (this.frame) window.cancelAnimationFrame(this.frame);
    this.frame = 0; this.needsScroll = false;
    this.desktopScrollPasses = 0;
    this.root.classList.remove("is-tour-active");
    var saved = this.saved;
    this.saved = null;
    if (saved) this.instance.setPreviewCollapsed(saved.collapsed, false);
    if (this.dialog.open) this.dialog.close();
    this.restoreDesktopScrolling();
    if (saved && !saved.hadClass) document.documentElement.classList.remove("fkc-tour-open");
    if (window.__fantastickTourOwner === this) window.__fantastickTourOwner = null;
    if (saved) {
      if (window.matchMedia("(max-width: 899px)").matches) window.scrollTo({ left: saved.x, top: saved.y, behavior: "instant" });
      else this.scrollDesktopWindow(saved.x, saved.y);
      if (restoreFocus && saved.opener && saved.opener.isConnected && !this.otherModalOpen()) saved.opener.focus({ preventScroll: true });
    }
    this.instance.updateControlScrollMargins();
  };
  Tour.prototype.destroy = function () {
    this.destroyed = true;
    this.close(false);
    window.clearTimeout(this.autoTimer);
    if (this.intersectionObserver) this.intersectionObserver.disconnect();
    if (this.resizeObserver) this.resizeObserver.disconnect();
    if (this.modalObserver) this.modalObserver.disconnect();
    this.listeners.forEach(function (remove) { remove(); });
    this.listeners = [];
    this.dialog.remove();
    if (this.button) this.button.disabled = true;
  };
  function attach(instance) {
    if (!instance || instance.tour || !instance.config.tour || instance.config.tour.enabled === false) return;
    var button = instance.root.querySelector("[data-fkc-tour-start]");
    if (!button) return;
    // A failed help module must never stop the configurator or a cart operation.
    try { instance.tour = new Tour(instance); }
    catch (error) { console.warn("Fantastick: Bedienhilfe konnte nicht gestartet werden.", error); button.hidden = true; }
  }
  window.FantastickConfiguratorTour = { version: "8.9.0", attach: attach, buildSteps: buildSteps };
  document.querySelectorAll('[data-fkc-ready="true"]').forEach(function (root) { if (root._fkcInstance) attach(root._fkcInstance); });
})();
